module.exports = __webpack_public_path__ + "ga.77886bd4d45974e2625e.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ga.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ga.svg
// module chunks = styles